import { Loader } from 'lucide-react';

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Hex code of the spinner color. Controls the color of the loading indicator.
   * @default '#FFFFFF'
   */
  color?: string;

  /**
   * Size of spinner icon in pixels. Controls both width and height of the spinner.
   * @default 24
   */
  size?: number;
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 24,
  color = '#FFFFFF',
  className,
  ...rest
}) => {
  return (
    <div {...rest} className={`flex items-center justify-center ${className}`}>
      <Loader
        size={size}
        color={color}
        className="animate-spin [animation-duration:2s]"
      />
    </div>
  );
};

export default Spinner;
